module.exports = __webpack_public_path__ + "static/media/17_r_stena_82.45_0.76c21bb2.png";